import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_info_line.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1936bd35")

_pushScopeId("data-v-1936bd35")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-daily-item-topspacer" }, null, -1)
const _hoisted_2 = { class: "fridgedoormonitor-daily-item-grapharea-scale" }
const _hoisted_3 = { class: "fridgedoormonitor-daily-item-grapharea-scale-y" }
const _hoisted_4 = { class: "fridgedoormonitor-daily-item-grapharea-scale-y-item" }
const _hoisted_5 = { class: "fridgedoormonitor-daily-item-grapharea-scale-y-item-text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-daily-item-grapharea-scale-spacer" }, null, -1)
const _hoisted_7 = { class: "fridgedoormonitor-daily-item-grapharea-scale-xitem-text" }
const _hoisted_8 = { class: "fridgedoormonitor-daily-item-grapharea-scale-yaxistitle" }
const _hoisted_9 = { class: "fridgedoormonitor-daily-item-grapharea-scale-yaxistitle-text" }
const _hoisted_10 = { class: "fridgedoormonitor-daily-item-grapharea-scale-xaxistitle" }
const _hoisted_11 = { class: "fridgedoormonitor-daily-item-grapharea-scale-xaxistitle-text" }
const _hoisted_12 = { class: "fridgedoormonitor-daily-item-grapharea-caution" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-daily-item-grapharea-caution-spacer" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "fridgedoormonitor-daily-item-grapharea-caution-item-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_15 = { class: "fridgedoormonitor-daily-item-notice" }
const _hoisted_16 = { class: "fridgedoormonitor-daily-item-notice-part" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "fridgedoormonitor-daily-item-notice-part-image",
  src: _imports_0
}, null, -1)
const _hoisted_18 = { class: "fridgedoormonitor-daily-item-notice-part-description" }
const _hoisted_19 = { class: "fridgedoormonitor-daily-item-notice-part-description-text" }
const _hoisted_20 = { class: "fridgedoormonitor-daily-item-description" }
const _hoisted_21 = { class: "fridgedoormonitor-daily-item-description-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "fridgedoormonitor-daily-item",
    ref: "scroll",
    onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.touchMainStart(...args))),
    onTouchmove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.touchMainMove(...args))),
    onTouchend: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.touchMainEnd(...args)))
  }, [
    _hoisted_1,
    _createVNode("div", {
      class: "fridgedoormonitor-daily-item-grapharea",
      style: _ctx.styleGraphArea
    }, [
      _createVNode("canvas", {
        class: "fridgedoormonitor-daily-item-grapharea-canvas",
        ref: "canvas",
        width: _ctx.canvasSize.width,
        height: _ctx.canvasSize.height
      }, null, 8, ["width", "height"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.yAxisScales, (scaleText) => {
            return (_openBlock(), _createBlock("div", { key: scaleText }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(scaleText), 1)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _hoisted_6,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.xAxisScales, (xscaleText) => {
          return (_openBlock(), _createBlock("div", {
            class: "fridgedoormonitor-daily-item-grapharea-scale-xitem",
            key: xscaleText
          }, [
            _createVNode("span", _hoisted_7, _toDisplayString(xscaleText), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.yAxisTitle), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.xAxisTitle), 1)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cautionStyles, (itemStyle) => {
          return (_openBlock(), _createBlock("div", {
            class: "fridgedoormonitor-daily-item-grapharea-caution-item",
            key: itemStyle.marginTop
          }, [
            (itemStyle.visible)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "fridgedoormonitor-daily-item-grapharea-caution-item-button",
                  style: { marginTop: itemStyle.marginTop },
                  onTouchStart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
                  onTouchMove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
                  onTouchEnd: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args))),
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickCaution(...args)))
                }, [
                  _hoisted_14
                ], 36))
              : _createCommentVNode("", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 4),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _createVNode("span", _hoisted_19, _toDisplayString(_ctx.noticeText), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.descriptionText), 1)
    ])
  ], 544))
})